import React, { useState } from "react";

import { Input, Modal, Button } from "antd";

import "./ReportCommentModal.css";

const { TextArea } = Input;

const MAX_COMMENT_CHAR_COUNT = 500;

export default function ReportCommentModal({
  open,
  onCancel,
  onSubmit,
  title,
  previousCommentTitle = "Comment",
  previousComment = "",
  loading,
  disabled = [false, false],
}) {
  const [comment, setComment] = useState("");

  const handleCancel = () => {
    setComment("");
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <Modal
      centered
      title={null}
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button
          key="back"
          onClick={handleCancel}
          disabled={loading || disabled[0]}
        >
          Cancel
        </Button>,
        <Button
          key="ok"
          type="primary"
          className="ReportCommentModal__Button"
          loading={loading}
          disabled={disabled[1] || comment.trim() === ""}
          onClick={() => {
            onSubmit({ data: comment });
            setComment("");
          }}
        >
          Submit
        </Button>,
      ]}
    >
      <div className="ReportCommentModal">
        {previousComment && (
          <div className="ReportCommentModal__PrevComment">
            <label className="ReportCommentModal__Label">
              {previousCommentTitle}
            </label>
            <p>{previousComment}</p>
          </div>
        )}
        <label className="ReportCommentModal__Label">
          {title || "Add a comment"}
        </label>
        <TextArea
          className="ReportCommentModal__TextArea"
          autoSize={{ minRows: 3, maxRows: 5 }}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          count={{
            show: true,
            max: MAX_COMMENT_CHAR_COUNT,
          }}
          maxLength={MAX_COMMENT_CHAR_COUNT}
          placeholder="Enter comment..."
        />
      </div>
    </Modal>
  );
}
